import { theme } from "../../utils/theme";

export enum Statuses {
  pending = "pending",
  dispatched = "dispatched",
  suspended = "suspended"
}

export const getStatusColour = (status: string | null): string => {
  switch (status) {
    case Statuses.pending:
      return theme.palette.yellow[300];
    case Statuses.dispatched:
      return theme.palette.green[300];
    case Statuses.suspended:
      return theme.palette.red[550];
    default:
      return theme.palette.common.white;
  }
} 